import {
  CALENDAR_CHEVRON_CLASS_MAP,
  CALENDAR_CHEVRON_ICON_MAP,
  type TCalendarChevronProps,
} from "@/ui/components/form/Calendar/Calendar.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";

export const CalendarChevron = ({
  className,
  disabled,
  orientation = "left",
  size: _size,
  style,
}: TCalendarChevronProps) => (
  <span
    aria-hidden="true"
    data-component="CalendarChevron"
    style={style}
    className={cn(
      CALENDAR_CHEVRON_CLASS_MAP.base,
      disabled && CALENDAR_CHEVRON_CLASS_MAP.disabled,
      className,
    )}
  >
    <Icon icon={CALENDAR_CHEVRON_ICON_MAP[orientation]} />
  </span>
);

CalendarChevron.displayName = "CalendarChevron";
